/**
 * Smooth Scroll Module
 * Handles smooth scrolling for anchor links
 */

export function initSmoothScroll(): void {
  document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e: MouseEvent) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;

      const target = document.querySelector(targetId!);
      if (target) {
        e.preventDefault();

        // Close mobile nav if open
        const navList = document.querySelector<HTMLElement>('.nav__list');
        const toggle = document.querySelector<HTMLButtonElement>('.nav__toggle');
        if (navList && navList.classList.contains('is-open')) {
          navList.classList.remove('is-open');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.classList.remove('is-active');
          }
        }

        // Scroll to target
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        // Set focus for accessibility
        const targetElement = target as HTMLElement;
        targetElement.setAttribute('tabindex', '-1');
        targetElement.focus({ preventScroll: true });
      }
    });
  });
}
